import { render, staticRenderFns } from "./CompanyDrawerRegisterTab.vue?vue&type=template&id=6c1596d2&scoped=true&"
import script from "./CompanyDrawerRegisterTab.vue?vue&type=script&lang=ts&"
export * from "./CompanyDrawerRegisterTab.vue?vue&type=script&lang=ts&"
import style0 from "./CompanyDrawerRegisterTab.vue?vue&type=style&index=0&id=6c1596d2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c1596d2",
  null
  
)

export default component.exports